import axios from '@/api/axios'

const getEventsSearchList = (params) => {
  return axios.get(`/events/rewardSearchList${params}`).then((res) => res.data)
}

export default {
  getEventsSearchList,
}
